var map = {
	"./train1.jpeg": "1534",
	"./train2.jpeg": "2db9",
	"./train3.jpeg": "7659",
	"./train4.jpeg": "349d",
	"./train5.jpeg": "1fed",
	"./train6.jpeg": "54c8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "478c";